module.exports = __webpack_public_path__ + "static/media/pa-light.b5f4c076.png";